import { Button, ButtonGroup } from "@clockwise/design-system";
import { ChevronLeft } from "@clockwise/design-system/icons";
import { ChevronRight } from "@clockwise/icons";
import classNames from "classnames";
import React from "react";
import { CalendarMode } from "../calendar-day-event";

export type HighlightedNavButton = "previous" | "next" | null;

type Props = {
  mode: CalendarMode;
  onNext: () => void;
  onPrevious: () => void;
  onToday: () => void;
  highlightedButton: HighlightedNavButton;
  tooltipText: string | null;
};

export const CalendarStepNavigation = ({
  mode,
  onPrevious,
  onToday,
  onNext,
  highlightedButton,
  tooltipText,
}: Props) => {
  const overlayStyles = classNames(
    "cw-absolute cw-top-0 cw-w-[30px] cw-h-[29px] cw-bg-neutral-emphasis cw-opacity-75",
    "cw-border cw-border-solid cw-border-default cw-shadow-timeSuggestionCard",
  );

  return (
    <div className="cw-w-full cw-relative">
      <ButtonGroup
        aria-label="calendar step navigation"
        sentiment="neutral"
        size="xsmall"
        variant="outlined"
      >
        <Button
          startIcon={ChevronLeft}
          aria-label={`Go to previous ${mode}`}
          onClick={onPrevious}
        ></Button>

        <Button aria-label="Go to today" onClick={onToday}>
          Today
        </Button>

        <Button
          startIcon={ChevronRight}
          aria-label={`Go to next ${mode}`}
          onClick={onNext}
        ></Button>
      </ButtonGroup>
      {highlightedButton === "previous" && (
        <div className="cw-animate-slowPulse">
          <div className={classNames(overlayStyles, "cw-rounded-l-md")} />
        </div>
      )}
      {highlightedButton === "next" && (
        <div className="cw-animate-slowPulse">
          <div className={classNames(overlayStyles, "cw-rounded-r-md cw-left-[82px]")} />
        </div>
      )}
      {tooltipText && (
        <div
          className={classNames(
            "cw-flex cw-body-small cw-text-13 cw-absolute cw-top-[34px] cw-p-3",
            "cw-bg-neutral-emphasis-pressed cw-rounded-lg cw-text-onEmphasis cw-min-w-[200px]",
          )}
        >
          {tooltipText}
        </div>
      )}
    </div>
  );
};
